// Facebook Pixel — loaded only after cookie consent (GDPR). Used on /test and,
// on demand, when a booking ("Je réserve mon bilan") is submitted from any page.
const PIXEL_ID = "1723998057888898";

// Inject the base pixel code + init. Returns true if a fresh load happened.
function injectPixel() {
  if (window.fbq) return false;
  const n = (window.fbq = function () {
    if (n.callMethod) n.callMethod.apply(n, arguments);
    else n.queue.push(arguments);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  const t = document.createElement("script");
  t.async = true;
  t.src = "https://connect.facebook.net/en_US/fbevents.js";
  const s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(t, s);
  window.fbq("init", PIXEL_ID);
  return true;
}

// Load pixel for the /test page (always records a PageView).
export function loadFacebookPixel() {
  if (typeof window === "undefined") return;
  injectPixel();
  window.fbq("track", "PageView");
}

// Ensure the pixel exists without an extra PageView (for conversions fired off /test).
export function ensureFacebookPixel() {
  if (typeof window === "undefined") return;
  if (injectPixel()) window.fbq("track", "PageView");
}

export function trackFacebookLead() {
  if (typeof window !== "undefined" && window.fbq) window.fbq("track", "Lead");
}

export function trackFacebookSchedule() {
  if (typeof window !== "undefined" && window.fbq) window.fbq("track", "Schedule");
}
